import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarCollapsed: false,
  globalLoading: false,
  activeModal: null,
  modalData: null,
  theme: "light",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,

  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },

    setSidebarCollapsed(state, action) {
      state.sidebarCollapsed = action.payload;
    },

    setGlobalLoading(state, action) {
      state.globalLoading = action.payload;
    },

    openModal(state, action) {
      state.activeModal = action.payload.key;
      state.modalData = action.payload.data ?? null;
    },

    closeModal(state) {
      state.activeModal = null;
      state.modalData = null;
    },

    setTheme(state, action) {
      state.theme = action.payload;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarCollapsed,
  setGlobalLoading,
  openModal,
  closeModal,
  setTheme,
} = uiSlice.actions;

export const selectSidebarCollapsed = (state) => state.ui.sidebarCollapsed;
export const selectGlobalLoading = (state) => state.ui.globalLoading;
export const selectActiveModal = (state) => state.ui.activeModal;
export const selectModalData = (state) => state.ui.modalData;
export const selectTheme = (state) => state.ui.theme;

export default uiSlice.reducer;
